import { ElementTextBlockPositionType, HeaderPositionType, PositionType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class TargetCategory extends BaseCategory {
    get name() {
        return "Target";
    }

    get type() {
        return SlideCategories.TARGET;
    }

    get icon() {
        return null;
    }

    get description() {
        return "The content represents concentric rings or layers, suitable for showing priorities, focus areas, or layered concepts. Use this for goal visualization, priority frameworks, market segmentation, or any content organized in nested levels from center outward.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Create a target/bullseye diagram with concentric rings. Each ring (band) can optionally be divided into segments but must include at least one segment. Parse the content to identify distinct layers or levels from center outward.`;
    }

    getImagePrompt() {
        return false;
    }

    getPromptSchema() {
        return {
            rings: [{
                segments: [{
                    label: "text label for the segment",
                }]
            }],
            conclusion: "an optional short conclusion or takeaway for the slide",
        };
    }

    validateGeneratedModel(model) {
        if (!this.validateArray(model.rings)) {
            return false;
        }
        return true;
    }

    getSlideModels(model, options = {}) {
        let models = [
            this.buildTarget(model, "inside", options),
            // this.buildTarget(model, "callout"),
        ];

        return models;
    }

    buildTarget(model, labelType, options = {}) {
        let builder = new SlideModelBuilder("target", model);
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        let primary = {
            collectionColor: "colorful-to-light",
            position: PositionType.CENTER,
            innerRadius: 0,
            outerRadius: 100,
            items: (model.rings || []).map(item => ({
                segments: (item.segments || [{ label: "" }]).map(segment => ({
                    labelType,
                    label: builder.cleanUpString(segment.label)
                }))
            })),
        };

        builder.createPrimary(primary);

        if (options.citeSources) {
            builder.createSourcesAttribution(model.sources);
        }

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.TRAY);
        }
        return builder.model;
    }
}
